/**
 * Created by Administrator on 2017/10/10.
 */
import imageClipper from './imageClipper.vue'

export default {
  install (Vue) {
    Vue.component(imageClipper.name, imageClipper)
  }
}



// WEBPACK FOOTER //
// ./src/components/base/imageClipper/index.js